export const API_ROOT = process.env.REACT_APP_API_ROOT;
export const GQL_ENDPOINT = process.env.REACT_APP_GQL_ENDPOINT;
export const STATIC_BASE_URL = process.env.REACT_APP_STATIC_BASE_URL;
export const CX_SERVER_BASE_URL = process.env.REACT_APP_CX_SERVER_BASE_URL;
export const CX_USER_DB_BASE_URL = process.env.REACT_APP_CX_USER_DB_BASE_URL;
export const CLOUD_FUNCTIONS_BASE_URL =
  process.env.REACT_APP_CLOUD_FUNCTIONS_BASE_URL;
export const CX_SERVER_API_KEY = process.env.REACT_APP_CX_SERVER_API_KEY;
export const CX_SERVER_ACCESS_TOKEN =
  process.env.REACT_APP_CX_SERVER_ACCESS_TOKEN;
export const DEFAULT_DOC_MALE = `${STATIC_BASE_URL}/male-doctor.png`;
export const DEFAULT_DOC_FEMALE = `${STATIC_BASE_URL}/female-doctor.png`;
export const TV_DISPLAY_URL = process.env.REACT_APP_TV_DISPLAY_URL;
export const COGNITO_BASE_URL = process.env.REACT_APP_COGNITO_BASE_URL;
export const COGNITO_API_KEY = process.env.REACT_APP_COGNITO_API_KEY;
export const USER_SERVICE_URL = process.env.REACT_APP_USER_SERVICE_URL;
export const S2S_CX_SERVER_API_KEY =
  process.env.REACT_APP_S2S_CX_SERVER_API_KEY;
export const S2S_C9USERMORE_API_KEY =
  process.env.REACT_APP_S2S_C9USERMORE_API_KEY;

export const vcApps = ['zoom'];

export const departmentType = [
  { value: 'Obstetrics', label: 'Obstetrics' },
  { value: 'Fertility', label: 'Fertility' },
  { value: 'Paediatrics', label: 'Paediatrics' },
  { value: 'Gynaecology', label: 'Gynaecology' },
  { value: 'Others', label: 'Others' }
];

export const visitReason = [
  {
    type: 'Obstetrics',
    options: [
      {
        value: 'Pregnancy Confirmation/Care',
        label: 'Pregnancy Confirmation/Care'
      },
      {
        value: 'Visiting Consultant Customer',
        label: 'Visiting Consultant Customer'
      },
      { value: 'Planning for Pregnancy', label: 'Planning for Pregnancy' },
      { value: 'Postpartum Consult', label: 'Postpartum Consult' },
      { value: 'Ultrasound/Lab', label: 'Ultrasound/Lab' },
      { value: 'Others (Mention Remarks)', label: 'Others (Mention Remarks)' }
    ]
  },
  {
    type: 'Gynaecology',
    options: [
      { value: 'Menstrual Problems', label: 'Menstrual Problems' },
      { value: 'Gynaecology Checkup', label: 'Gynaecology Checkup' },
      {
        value: 'Visiting Consultant Customer',
        label: 'Visiting Consultant Customer'
      },
      { value: 'Surgery Related Visit', label: 'Surgery Related Visit' },
      { value: 'Ultrasound/Lab', label: 'Ultrasound/Lab' },
      { value: 'Others (Mention Remarks)', label: 'Others (Mention Remarks)' }
    ]
  },
  {
    type: 'Fertility',
    options: [
      { value: 'Second Opinion', label: 'Second Opinion' },
      { value: 'Infertility Issues', label: 'Infertility Issues' },
      {
        value: 'Infertility Screening',
        label: 'Infertility Screening'
      },
      { value: 'Ultrasound/Lab', label: 'Ultrasound/Lab' },
      { value: 'Others (Mention Remarks)', label: 'Others (Mention Remarks)' }
    ]
  },
  {
    type: 'Paediatrics',
    options: [
      { value: 'General Consultation', label: 'General Consultation' },
      { value: 'Vaccination/Injection', label: 'Vaccination/Injection' },
      {
        value: 'PICU/NICU Admission',
        label: 'PICU/NICU Admission'
      },
      { value: 'Others (Mention Remarks)', label: 'Others (Mention Remarks)' }
    ]
  },
  {
    type: 'Others',
    options: [
      { value: 'Consultation', label: 'Consultation' },
      { value: 'Others (Mention Remarks)', label: 'Others (Mention Remarks)' }
    ]
  }
];

export const source = [
  { value: 'Friend/Family Referral', label: 'Friend/Family Referral' },
  {
    value: 'Digital (Google/FB/Website)',
    label: 'Digital (Google/FB/Website)'
  },
  { value: 'Call Center', label: 'Call Center' },
  {
    value: 'Affiliates (Practo, Medibuddy etc.,)',
    label: 'Affiliates (Practo, Medibuddy etc.,)'
  },
  {
    value: 'Doctor Referral - Internal Consultant',
    label: 'Doctor Referral - Internal Consultant'
  },
  {
    value: 'Doctor Referral - Visiting Consultant',
    label: 'Doctor Referral - Visiting Consultant'
  }
];

export const gender = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' }
];
